import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/ubuntu/cal-ay/apps/web/modules/apps/[slug]/slug-view.tsx");
